<template>
    <div class="version2-left-bottom">
        <div class="version2-left-bottom-block">
            <Header title="专利海外布局"></Header>
            <Bar :options="options" @echartClick="echartClick"></Bar>
        </div>
    </div>
</template>
<script>
import Header from '../commonHeader/one.vue'
import BaseMixin from '@/views/_mixin'
import Bar from '@/components/echarts/Bar'
import { getValuePCT } from '@/api/databaseBin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      options: {}
    }
  },
  components: {
    Header,
    Bar
  },
  mounted() {
    this.init()
  },
  methods: {
    echartClick(params) {
      let exp = '数据源=' + params.data.name
      if (params.data.name === '其他') {
        exp = `数据源=(US or EP or JP or KR or GB or FR or DE or RU or CH or WO or OTHER) ${params.data.exp}`
      }
      this.jumpIpi(exp, 'isMerge', 'publicOrder')
    },
    async init() {
      const result = await getValuePCT()
      const { datas, total } = result[this.dataMapping]
      const xAxis = []
      const obj = {
        '世界知识产权组织国际局(WIPO)': 'WIPO',
        美国: 'US',
        '欧洲专利局(EPO)': 'EPO',
        日本: 'JP',
        其他: 'OTHER'
      }
      datas.forEach(item => {
        item.value = item.count
        item.value = item.count
        if (item.name.indexOf('WO') !== -1) {
          item.name = 'WIPO'
        }
        if (item.name.indexOf('EP') !== -1) {
          item.name = 'EPO'
        }
        item.type = obj[item.name]
        xAxis.push(item.name)
        // item.name = item.name + item.per
      })

      this.pctArr = datas
      this.total = total
      const data = datas
      const barWidth = 20
      this.options = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            const str = params[0].marker + params[0].name + ': ' + params[0].value
            return str
          }
        },
        // 图表大小位置限制
        grid: {
          x: '10%',
          x2: '5%',
          y: '15%',
          y2: '15%'

        },
        xAxis: {
          data: xAxis,
          // 坐标轴
          type: 'category',
          axisLabel: {
            overflow: 'none',
            ellipsis: '...',
            formatter(val) {
              if (val.length > 2) {
                return val.slice(0, 2) + '...'
              } else {
                return val
              }
            },
            textStyle: {
              color: '#C5DFFB',
              fontWeight: 500,
              fontSize: '14'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          min: 0, // 最小
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          // 坐标值标注
          axisLabel: {
            show: true,
            textStyle: {
              color: '#F2F6FF'
            }
          }
        },
        series: [
        // 中
          {
            z: 1,
            type: 'bar',
            barWidth: barWidth,
            barGap: '0%',
            data: data,
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(11, 79, 86, .32)'
            },
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  x2: 1,
                  y: 0,
                  y2: 0,
                  colorStops: [
                    { offset: 0, color: '#00E8CF' },
                    { offset: 0.5, color: '#00E8CF' },
                    { offset: 0.5, color: '#02C2AF' },
                    { offset: 1, color: '#02C2AF' }
                  ]
                },
                // 柱形图上方标题
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  },
                  formatter(val) {

                  }
                }
              }
            }
          },
          // 下
          {
            z: 2,
            type: 'pictorialBar',
            data: data.map(item => item + 90),
            symbol: 'diamond',
            symbolOffset: ['0%', '0%'],
            symbolSize: [barWidth, 10],
            itemStyle: {
              normal: {
                color: 'transparent'
              }
            },
            tooltip: {
              show: false
            }
          },
          // 上
          {
            z: 3,
            type: 'pictorialBar',
            symbolPosition: 'end',
            data: data,
            symbol: 'diamond',
            symbolOffset: ['0%', '-90%'],
            symbolSize: [barWidth - 4, (10 * (barWidth - 4)) / barWidth],
            itemStyle: {
              normal: {
                borderWidth: 10,
                color: '#00E8CF'
              }
            },
            tooltip: {
              show: false
            }
          }
        ]
      }
    }
  }
}
</script>
